import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const fmt = (d) => (d ? new Date(d).toLocaleDateString() : "—");

export const AdminSubscriptions = () => {
  const [data, setData] = useState(null);
  const [filter, setFilter] = useState("all");
  useEffect(() => { api.get("/admin/subscriptions").then((r) => setData(r.data)).catch((e) => { toast.error(errMsg(e)); setData({ subscriptions: [] }); }); }, []);
  const rows = (data?.subscriptions || []).filter((r) => filter === "all" || r.status === filter);
  return (
    <section className="panel p-6" data-testid="admin-subscriptions">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <h2 className="text-lg font-semibold">Subscriptions</h2>
        {data && <span className="text-xs text-muted-foreground" data-testid="admin-subs-counts">{data.active ?? 0} active · {data.expired ?? 0} expired</span>}
        <div className="ml-auto flex gap-1">
          {["all", "active", "expired"].map((f) => (
            <button key={f} data-testid={`admin-subs-filter-${f}`} onClick={() => setFilter(f)}
              className={`text-xs rounded-full px-3 py-1 capitalize ${filter === f ? "brand-gradient text-white" : "border border-border"}`}>{f}</button>
          ))}
        </div>
      </div>
      {!data && <Loader2 className="h-5 w-5 animate-spin text-primary" />}
      {data && rows.length === 0 && <p className="text-sm text-muted-foreground">No subscriptions yet.</p>}
      {rows.length > 0 && (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-left text-xs text-muted-foreground"><tr><th className="py-2">User</th><th>Plan</th><th>Credits left</th><th>Started</th><th>Expires</th><th>Status</th></tr></thead>
            <tbody>
              {rows.map((r) => (
                <tr key={`${r.user_email}-${r.premium_until}`} className="border-t border-border" data-testid="admin-sub-row">
                  <td className="py-2">{r.user_email || "—"}</td>
                  <td>{r.plan_name}</td>
                  <td>{r.credits_remaining.toLocaleString()} / {r.credits_total.toLocaleString()}</td>
                  <td>{fmt(r.started_at)}</td>
                  <td>{fmt(r.premium_until)}</td>
                  <td><span className={`text-[11px] font-bold uppercase rounded-full px-2 py-0.5 ${r.status === "active" ? "bg-emerald-500/15 text-emerald-400" : "bg-secondary text-muted-foreground"}`}>{r.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
